import ScalarIconFileText_vue_vue_type_script_setup_true_lang_default from "./ScalarIconFileText.vue.script.js";
//#region src/components/ScalarIconFileText.vue
var ScalarIconFileText_default = ScalarIconFileText_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconFileText_default as default };

//# sourceMappingURL=ScalarIconFileText.js.map